import React from 'react';

import MainPage from './pages/MainPage/MainPage';

class App extends React.Component {
  render(){
    return (
      <>
        <MainPage />
      </>
    );
  }
};

export default App;
